import { render } from "./VentureResources.vue?vue&type=template&id=e084bd9c&scoped=true"
import script from "./VentureResources.vue?vue&type=script&lang=js"
export * from "./VentureResources.vue?vue&type=script&lang=js"

import "./VentureResources.vue?vue&type=style&index=0&id=e084bd9c&scoped=true&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e084bd9c"]])

export default __exports__